import {Editor} from '@tinymce/tinymce-react';
import { action, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {tinyMceConfig} from '../../../../lib/helpers';
import {EditContentStore} from '../../x7/content-parts/EditContentStore';

const TinyMceInit = tinyMceConfig.init;

@observer
export class X9StaticHtmlEdit extends React.Component<{ store: EditContentStore }> {
  @action
  handleEditorChange = (content: string) => {
    this.props.store.setContents(content);
  };

  constructor(props: { store: EditContentStore }) {
    super(props);
    makeObservable(this);
  }

  render() {
    return (<Editor init={TinyMceInit}
                    value={this.props.store.contents}
                    onEditorChange={this.handleEditorChange}/>);
  }
}
